import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ExportExcelModalComponent} from './export-excel-modal.component';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ButtonGroupModule} from '../../../button-group/button-group.module';
import {LabelModule} from '../../../label/label.module';
import {ModalModule} from '../modal/modal.module';
import {ModalButtonGroupModule} from '../modal-button-group/modal-button-group.module';
import {FieldGridModule} from "../../../field-grid/field-grid.module";
import {FieldModule} from "../../../../fields/field.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {ButtonModule} from "../../../button/button.module";
import {EnumEditFieldModule} from "../../../../fields/enum/templates/edit/enum.module";


@NgModule({
    declarations: [ExportExcelModalComponent],
    exports: [ExportExcelModalComponent],
    imports: [
        CommonModule,
        ModalModule,
        ButtonGroupModule,
        LabelModule,
        ModalButtonGroupModule,
        NgbModule,
        FieldGridModule,
        FieldModule,
        ReactiveFormsModule,
        ButtonModule,
        EnumEditFieldModule,
        FormsModule,
    ],
})
export class ExportExcelModalModule {
}
